// Bootstrap JS
// @devnote comment this line if you plan to
// use the CDN version of boostrap js
import * as bootstrap from 'bootstrap';
import { watchNavbarCollapse } from './lib/navbar';
import { watchScroll } from './lib/scroll';
import { silenceModalsOnDismiss } from './lib/video';

window.bootstrap = bootstrap;


// App


/**
 * Benchmarking
 */
const timeStart = window.performance.now();



document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Load Webfonts
	 */

	// Do stuff...
	watchScroll();
	silenceModalsOnDismiss();
	watchNavbarCollapse();

	/**
	 * Benchmarking reporting
	 */
	const timeEnd = window.performance.now();
	console.info(
		`Execution time: ${timeEnd - timeStart}ms after DOMContentLoaded.`
	);
});
